const DEFAULT_ERROR_CODE = '0';
const DEFAULT_ERROR_CODE_NAME = 'Undefined error';

class ApiError extends Error {
  constructor({
    code = DEFAULT_ERROR_CODE,
    codeName = DEFAULT_ERROR_CODE_NAME,
  } = {}) {
    super('ApiError');
    this.name = this.constructor.name;
    this.code = code;
    this.codeName = codeName;
  }
}

module.exports = { ApiError, DEFAULT_ERROR_CODE, DEFAULT_ERROR_CODE_NAME };
